export const UseCasePageLayout = {
  slots: ['SlbCaseStudiesContainerSlot'],
};
